module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB2SURBVDhPY/z//z8DJYBx0qRJFJkANsDK0grKJR4cO36MIS8vj4EFymdwMz0LZREHGiZBaCYIhRu8/pvC8I4hHYOGAbgXQE4iFYC8wAAy4MzpM////v1LEoYG/n+CXiAERg2gggEU5QVQOmAE0pRlJsqyMwMDAAXOYlXb0guMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/EXEC_16.png
// module id = 57
// module chunks = 0